exports.ELECTRIC_VEHICLE = {
  ENV: "ENV",
  ECA: "ECA",
  EAV: "EAV",
  PAX: "PAX",
  RED: "RED",
  PAR: "PAR",
};
